var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMaster(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Outline",
    viewBox: "0 0 512 512",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256,248a48,48,0,1,0-48-48A48.055,48.055,0,0,0,256,248Zm0-80a32,32,0,1,1-32,32A32.036,32.036,0,0,1,256,168Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M256,208h8a8,8,0,0,0,0-16v-8a8,8,0,0,0-16,0v16A8,8,0,0,0,256,208Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M320,304V272a8,8,0,0,0-8-8H200a8,8,0,0,0-8,8v32a8,8,0,0,0,8,8H312A8,8,0,0,0,320,304Zm-16-8H208V280h96Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M72,264h64a8,8,0,0,0,0-16V192a8,8,0,0,0-8-8H80a8,8,0,0,0-8,8v56a8,8,0,0,0,0,16Zm16-64h32v48H88Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M136,344V288a8,8,0,0,0-8-8H80a8,8,0,0,0-8,8v56a8,8,0,0,0,0,16h64a8,8,0,0,0,0-16ZM88,296h32v48H88Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M136,440V384a8,8,0,0,0-8-8H80a8,8,0,0,0-8,8v56a8,8,0,0,0,0,16h64a8,8,0,0,0,0-16ZM88,392h32v48H88Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M376,264h64a8,8,0,0,0,0-16V192a8,8,0,0,0-8-8H384a8,8,0,0,0-8,8v56a8,8,0,0,0,0,16Zm16-64h32v48H392Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M376,360h64a8,8,0,0,0,0-16V288a8,8,0,0,0-8-8H384a8,8,0,0,0-8,8v56a8,8,0,0,0,0,16Zm16-64h32v48H392Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M376,456h64a8,8,0,0,0,0-16V384a8,8,0,0,0-8-8H384a8,8,0,0,0-8,8v56a8,8,0,0,0,0,16Zm16-64h32v48H392Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M488,160a8,8,0,0,0,0-16H346.6L264,83.926V65.444l38.685,6.447A8,8,0,0,0,312,64V32a8,8,0,0,0-6.685-7.891l-48-8v.008A7.954,7.954,0,0,0,248,24V83.926L165.4,144H24a8,8,0,0,0,0,16h8V480H24a8,8,0,0,0,0,16H488a8,8,0,0,0,0-16h-8V160ZM248,480H216V392a40.067,40.067,0,0,1,32-39.195Zm16-127.195A40.067,40.067,0,0,1,296,392v88H264ZM256,336a56.064,56.064,0,0,0-56,56v88H176V156.074l80-58.182,80,58.182V480H312V392A56.064,56.064,0,0,0,256,336ZM296,54.556l-32-5.333V33.444l32,5.333ZM48,160H160V480H48ZM464,480H352V160H464Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaster);
export default __webpack_public_path__ + "static/media/master.393c89a0.svg";
export { ForwardRef as ReactComponent };